module.exports = __webpack_public_path__ + "2668a62f515dad0950c9e71c762350d1.jpg";